import { EmeraldIcon } from "@emerald-react/icon";

interface MapRecenterProps {
    onRecenterChange: (e: any) => void;
}

const MapCenter = (props: MapRecenterProps) => {
    const { onRecenterChange } = props;

    return (
        <section>
            <EmeraldIcon
                icon="recenter"
                type="outlined"
                variant="symbol"
                onClick={onRecenterChange}
                className="absolute right-2 top-28 z-1 p-[2.5px] bg-white rounded-sm text-map-icon border-2 border-map-light"
            />
        </section>
    );
};

export default MapCenter;
